module.exports = __webpack_public_path__ + "img/3.29043f74.png";